import React from "react";

const Terms = () => {
  return (
    <div className="bg-white">
      {/* HERO */}
      <section className="relative w-full overflow-hidden">
        <div className="relative w-full h-[300px] md:h-[360px] flex">
          <div
            className="relative z-10 flex items-center text-white"
            style={{
              width: "55%",
              backgroundColor: "#e11d7b",
              clipPath: "polygon(0 0, 100% 0, 92% 35%, 78% 100%, 0 100%)"
            }}
          >
            <div className="max-w-xl pl-8 md:pl-16 pr-10">
              <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
                Conditions d’utilisation
              </h1>
              <p className="mt-4 text-base md:text-lg text-white/90">
                Règles d’utilisation du site Maxula.ma
              </p>
            </div>
          </div>

          <div
            className="absolute right-0 top-0 h-full w-full"
            style={{
              background:
                "linear-gradient(to right, #e11d7b 0%, rgba(225,29,123,0.55) 45%, rgba(225,29,123,0.15) 70%, transparent 100%)"
            }}
          />
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <div className="bg-white border rounded-2xl p-6 text-gray-700 leading-relaxed">
            <h2 className="text-xl font-bold text-gray-900">1. Objet</h2>
            <p className="mt-2">
              Ces conditions encadrent l’accès et l’utilisation de Maxula.ma (navigation, création de compte,
              réservation, achat, consultation de contenus).
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-6">2. Comptes et sécurité</h2>
            <p className="mt-2">
              Vous êtes responsable de la confidentialité de vos identifiants. Toute utilisation via votre compte est
              réputée effectuée par vous.
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-6">3. Rôle de Maxula</h2>
            <p className="mt-2">
              Maxula agit comme intermédiaire de mise en relation. Les prestations sont réalisées par les partenaires.
              Les conditions officielles de vente et de remboursement sont définies dans la page <b>CGV</b>.
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-6">4. Propriété intellectuelle</h2>
            <p className="mt-2">
              Le contenu, la marque, le design et les éléments du site sont protégés. Toute reproduction non autorisée
              est interdite.
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-6">5. Contact</h2>
            <p className="mt-2">
              Email : <b>contact@maxula.ma</b> — Tanger, Maroc.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
